<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
              <div class="d-flex flex-column justify-content-center mr-auto">
                <h5 class="mb-0"></h5>
              </div>
                <div class="d-flex flex-column justify-content-center">
                    <a class="btn btn-primary" href="javascript: void(0);" @click="usePageBank()">ตรวจสอบบัญชีธนาคาร</a>
                </div>
            </div>
            <div class="card-header card-header-flex">
                <search v-bind="sentDataSearch"></search>
            </div>
            <div class="card-body">
               <tableUserBank v-bind="sentTableUserBank"></tableUserBank>
            </div>
        </div>
        <!-- <a-modal title="ค้นหาบัญชีธนาคาร" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" @cancel="handleCancel">

        </a-modal> -->
    </div>
</template>

<script>
import tableUserBank from './tableUserBank'
import search from '@/components/system/table/search/users'

export default {
  components: {
    tableUserBank,
    search,
  },
  data() {
    return {
      pageType: 'userBank',
      visible: false,
    }
  },
  computed: {
    sentDataSearch: function() {
      return {
        pageType: this.pageType,
      }
    },
    sentTableUserBank: function() {
      return {
        pageType: this.pageType,
      }
    },
  },
  methods: {
    usePageBank() {
      const routeData = this.$router.resolve({ name: 'checkBank' })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style>

</style>
